import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IPlaylistSortInfo } from './VideoPlaylist.Contract';

import styles from './video-playlist-header.module.less';

@Component({
	selector: 'video-playlist-header',
	templateUrl: './VideoPlaylistHeader.Component.html'
})

export class VideoPlaylistHeaderComponent {
	@Input() public sortInfo: IPlaylistSortInfo;
	@Output() public onAddNewClick: EventEmitter<any> = new EventEmitter();
	@Output() public onSortChange: EventEmitter<any> = new EventEmitter();
	@Output() public onSelectAllPlaylistsChange: EventEmitter<boolean> = new EventEmitter();

	public readonly styles = styles;
	public selectAllPlaylists: boolean;
}
